function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShrimp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9A4C00"
    },
    d: "M56.786,119.058h-9.25C21.325,119.058,0,97.733,0,71.521s21.325-47.537,47.537-47.537h72.304v31.411 H47.537c-8.891,0-16.125,7.234-16.125,16.125s7.234,16.124,16.125,16.124h9.25V119.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7953"
    },
    d: "M512,261.144c0,95.668-77.826,173.505-173.494,173.505v-31.411h0.052 c32.479-0.031,58.906-26.469,58.906-58.959c0-4.021-0.408-7.947-1.183-11.748c-2.146-10.638-7.172-20.239-14.24-27.966 c-7.591-8.324-17.538-14.46-28.773-17.37c-4.722-1.225-9.664-1.874-14.763-1.874H184.067l-0.482-0.031 c-0.304-0.021-1.979-0.136-4.691-0.482c-13.015-1.696-46.656-8.376-77.805-33.914c-17.957-14.711-32.123-33.338-42.133-55.346 c-11.863-26.092-17.873-57.116-17.873-92.192V87.65h297.422c6.9,0,13.695,0.408,20.386,1.194 c47.797,5.612,89.71,30.741,117.541,67.168c10.868,14.219,19.58,30.155,25.673,47.326C508.513,221.43,512,240.884,512,261.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4F18"
    },
    d: "M439.231,361.251c-8.921,21.433-25.946,36.248-46.342,46.572 c-12.146,6.136-24.993,10.826-37.955,14.941c-5.298,1.686-10.795,3.141-16.428,4.387v-23.914h0.052 c32.479-0.031,58.906-26.469,58.906-58.959c0-4.021-0.408-7.947-1.183-11.748c-2.146-10.638-7.172-20.239-14.24-27.966 c-7.591-8.324-17.538-14.46-28.773-17.37c-4.722-1.225-9.664-1.874-14.763-1.874H184.067l-0.482-0.031 c-0.304-0.021-1.979-0.136-4.691-0.482c-13.015-1.696-46.656-8.376-77.805-33.914c-17.957-14.711-32.123-33.338-42.133-55.346 c0,0,321.598,0,321.881,0c9.266,0,23.391,11.277,30.238,16.355c14.669,10.868,26.448,25.171,33.243,41.861 c2.272,5.57,3.989,11.402,5.068,17.465c1.225,6.848,1.885,14.198,2.031,21.778C451.869,316.135,447.471,341.441,439.231,361.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9A4C00"
    },
    d: "M354.939,422.768h-64.282c-30.368,0-54.987-24.619-54.987-54.987v-10.26h64.282 c30.369,0,54.987,24.619,54.987,54.987V422.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#723700"
    },
    d: "M354.939,422.768h-64.282c-30.368,0-54.987,24.619-54.987,54.987v10.26h64.282 c30.369,0,54.987-24.619,54.987-54.987V422.768z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDBA8"
    },
    d: "M257.454,195.547c-1.874,26.836-9.591,57.294-27.663,89.773h-36.72 c19.548-29.579,30.584-59.608,33.045-89.773c1.413-17.297,0.01-34.636-4.23-51.965c-6.554-26.815-18.501-46.614-24.951-55.933 h36.772c6.523,12.083,13.517,27.966,18.313,46.928C256.282,151.414,259.098,172.093,257.454,195.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDBA8"
    },
    d: "M381.12,195.558c-1.864,27.411-9.643,58.488-27.851,91.637c-4.722-1.225-9.664-1.874-14.763-1.874 H317.91c18.847-29.6,29.506-59.618,31.893-89.773c1.466-18.281-0.115-36.615-4.754-54.938 c-6.125-24.176-16.208-42.499-23.014-52.959h16.47c6.9,0,13.695,0.408,20.386,1.194c6.041,11.832,12.219,26.699,16.606,44.059 C379.874,150.221,382.774,171.465,381.12,195.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDBA8"
    },
    d: "M502.105,203.337c-1.267,5.162-2.806,10.512-4.649,15.988c-7.497,22.197-21.161,48.96-46.038,73.68 c-14.334,14.271-32.385,27.862-55.137,39.526c-2.146-10.638-7.172-20.239-14.24-27.966c25.988-13.276,46.803-30.259,62.278-50.802 c9.8-12.994,17.454-27.411,22.941-43.222c7.79-22.459,9.203-42.635,9.172-54.53C487.3,170.23,496.012,186.166,502.105,203.337z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.004,
    y: 138.733,
    style: {
      fill: "#FFDBA8"
    },
    width: 24.522,
    height: 24.522
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC473"
    },
    d: "M226.116,195.547h31.338c-1.874,26.836-9.591,57.294-27.663,89.773h-36.72 C212.62,255.741,223.656,225.712,226.116,195.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC473"
    },
    d: "M338.506,285.32H317.91c18.847-29.6,29.506-59.618,31.893-89.773h31.034c0.094,0,0.188,0,0.283,0.01 c-1.864,27.411-9.643,58.488-27.851,91.637C348.547,285.969,343.605,285.32,338.506,285.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC473"
    },
    d: "M451.418,293.004c-14.334,14.271-32.385,27.862-55.137,39.526 c-2.146-10.638-7.172-20.239-14.24-27.966c25.988-13.276,46.803-30.259,62.278-50.802c2.272,5.57,3.989,11.402,5.068,17.465 C450.612,278.075,451.272,285.425,451.418,293.004z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShrimp);
export default __webpack_public_path__ + "static/media/shrimp.223b2f5c8e9d21916ab3b33f25ffeb1f.svg";
export { ForwardRef as ReactComponent };